import { PageWrapper } from "../forgot-password/forgot-password.styles";
import ForgotPasswordPane from "../forgot-password-pane/forgot-password-pane.component";
import ForgotPasswordCanvas from "../forgot-password-canvas/forgot-password-canvas.component";
import React from "react";
import { ForgotPasswordViewProps } from "./forgot-password-view.props";

export const ForgotPasswordView = (props: ForgotPasswordViewProps) => (
  <PageWrapper>
    <ForgotPasswordPane
      userData={props.userDataValues}
      errors={props.errors}
      loading={props.loading}
      handleChange={props.onChange}
      handleSubmit={props.onSubmit}
      handleBackToLogin={props.onBackToLogin}
    />
    <ForgotPasswordCanvas />
  </PageWrapper>
);
